var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"menu"},_vm._l((_vm.sections),function(section){return _c('div',{key:section.path,staticClass:"menu-item-spacer"},[_c('router-link',{attrs:{"to":section.path}},[_c('div',{staticClass:"menu-item hover-grow",class:{
                        'menu-item-selected': section.path === _vm.current,
                    }},[_vm._v(" "+_vm._s(section.name)+" ")])])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }